module.exports = __webpack_public_path__ + "img/btn_join.78a65be.webp";